/**
 * Render a diff value for display. Its own module rather than a named export from a
 * component file, which trips the react-refresh lint rule (a file that exports both
 * components and helpers breaks fast refresh).
 */
export function formatValue(value: unknown): string {
  if (value === null || value === undefined) return "—";
  if (Array.isArray(value)) return value.length > 0 ? value.join(", ") : "—";
  if (typeof value === "boolean") return value ? "yes" : "no";
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
}
